import styled from "styled-components";
import { DataHeading } from "../../commonStyles";

export const TitleDataHeading = styled(DataHeading)`
  @media (max-width: 576px) {
    margin-bottom: 5px;
  }
`;
